import { Component, EventEmitter, forwardRef, HostBinding, HostListener, Input, Output } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { IconEnum, SvgIconComponent } from "@evc/web-components";

export interface CheckboxChangeEvent {
  cancel?: boolean;
  value: boolean;
}
@Component({
  selector: "app-checkbox",
  imports: [SvgIconComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ],
  templateUrl: "./checkbox.component.html",
  styleUrl: "./checkbox.component.scss"
})
export class CheckboxComponent implements ControlValueAccessor {
  readonly checkedIcon = IconEnum.SquareCheck;
  readonly unCheckedIcon = IconEnum.Square;

  private onChange = (value: boolean) => {};
  private onTouched = () => {};

  @Input() label: string = "";
  @Input() checked: boolean = false;
  @Output() checkedChange = new EventEmitter<CheckboxChangeEvent>();
  @HostBinding("class.disabled") @Input() isDisabled = false;

  @HostListener("click") onClick() {
    const event = {
      cancel: false,
      value: !this.checked
    };
    try {
      this.checkedChange?.emit(event);
    } finally {
      if (event.cancel) {
        return;
      }
    }
    this.checked = !this.checked;
    this.onChange(this.checked);
  }

  writeValue(value: boolean): void {
    this.checked = value;
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
